import {FormPost, GET, POST} from "../util";

const registrationUrl = "api/registration/";

const url = {
    submitInitialRegistration: `${registrationUrl}submit`,
    settings: `${registrationUrl}settings`,
    checkInvitationCode: `${registrationUrl}invitation-code/check`,
    checkLegalData: `${registrationUrl}legal/check`,
    checkBankAccount: `${registrationUrl}bank-account/check`,
    uploadRegistrationDocument: `${registrationUrl}registration-document/upload`,
    resendMail: `${registrationUrl}resend-mail`,
};

const registrationApi = {
    submitInitialRegistration: function submit(params = {}) {
        return POST(url.submitInitialRegistration, params);
    },
    getSettings: (code) => {
        return GET(url.settings + "/" + code);
    },
    checkInvitationCode: (code) => {
        return GET(url.checkInvitationCode + "/" + code);
    },
    checkLegalData: (data) => {
        return POST(url.checkLegalData, data);
    },
    checkBankAccount: (data) => {
        return POST(url.checkBankAccount, data);
    },
    uploadRegistrationDocument: (params) => {
        return FormPost(url.uploadRegistrationDocument, params);
    },
    resendMail: (email) => {
        return POST(url.resendMail, email, "application/json", 'String');
    }
};
export {
    registrationApi
};